module.exports = __webpack_public_path__ + "h5/img/fangxin.89756405.png";